import React from 'react';
import { ThemeProvider } from '@mui/material/styles';

import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';

import { AuthProvider } from './hooks/useAuth';
import AuthInitializer from './utilities/AuthInitializer/AuthInitializer';
import PageRouter from './PageRouter';

function App() {
  return (
    <AuthProvider>
      <AuthInitializer>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <PageRouter />
        </ThemeProvider>
      </AuthInitializer>
    </AuthProvider>
  );
}

export default App;
